export default {
  SuccessWithdraw: 'SuccessWithdraw',
  Message: 'Message',
  ErrorNotification: 'ErrorNotification',
  BTCMultisignRequest: 'BTCMultisignRequest',
  Transaction: 'Transaction',
}
